import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { IssuePermitTransactionModel } from '../../titleregistration/models/issue-permit-transaction.model';
import { HomemadeVehicleModel } from '../models/homemade-vehicle.model';
import { VehiclePermitModel } from '../models/vehicle-permit.model';

@Injectable()
export class VehiclePermitService extends BaseApiService {

    getIssuePermitTransaction(businessTransactionId: number) {
        return this.get('Vehicle/VehiclePermit/Trn/' + businessTransactionId);
    }

    getPermitByPermitNumber(permitNumber: string) {
        return this.get('Vehicle/VehiclePermit/PermitNumber/' + permitNumber);
    }

    getPermitsByContainingPermitNumber(permitNumber: string) {
        return this.get('Vehicle/VehiclePermit/ContainsPermitNumber/' + permitNumber);
    }

    getPermitsByCustomerNumber(customerNumberId: number): Observable<VehiclePermitModel[]> {
        return this.get('Vehicle/VehiclePermit/CustomerNumber/' + customerNumberId);
    }

    getPermitsByVehicleId(vehicleId: number) {
        return this.get('Vehicle/VehiclePermit/VehicleId/' + vehicleId);
    }

    saveVehiclePermits(issuePermitTransaction: IssuePermitTransactionModel, businessTransactionId: number) {
        return this.post('Vehicle/VehiclePermit/Trn/' + businessTransactionId + '/Permits', issuePermitTransaction);
    }

    saveHomemadeVehicle(homemadeVehicle: HomemadeVehicleModel, businessTransactionId: number) {
        return this.post('Vehicle/VehiclePermit/Trn/' + businessTransactionId + '/UpdateHomemadeVehicle', homemadeVehicle);
    }

    validateHommadeVehicle(homemadeVehicle: HomemadeVehicleModel) {
        return this.post('Vehicle/VehiclePermit/Validate/HomemadeVehicle', homemadeVehicle);
    }

    updatePermitExpirationDate(vehiclePermitModel: VehiclePermitModel) {
        return this.post('Vehicle/VehiclePermit/UpdatePermitExpirationDate', vehiclePermitModel);
    }

    createCancelPermitTransaction(vehiclePermitId: number) {
        return this.get('Vehicle/VehiclePermit/Cancel/' + vehiclePermitId + '/Create');
    }

    createDuplicatePermitTransaction(vehiclePermitId: number) {
        return this.get('Vehicle/VehiclePermit/Duplicate/' + vehiclePermitId + '/Create');
    }
}
